export function extractComponentsFromGooglePlace(place) {
  let addressComponents = [];
  if (place && place.address_components) {
    addressComponents = place.address_components;
  } else if (place && typeof place === 'object') {
    addressComponents = place;
  }
  const getAddressComponent = (type: string) =>
    addressComponents
      .map((c) => {
        if (c && c.Dg) {
          if (c.Dg[0] === type) {
            return c.Eg;
          }
        }
        if (c.types[0] === type) {
          return c.longText ?? c.long_name;
        }
      })
      .filter((c) => c)[0];
  const line1 = [getAddressComponent('street_number') || '', getAddressComponent('route') || ''].filter(Boolean).join(' ').trim();
  const line2 = getAddressComponent('locality') || getAddressComponent('postal_town') || '';
  const line3 = getAddressComponent('administrative_area_level_1') || '';
  const code = getAddressComponent('postal_code') || '';
  const suburb = getAddressComponent('sublocality_level_1') || '';
  return { line1, line2, line3, code, suburb };
}

// old object for place auto
// [
//     {
//         "longText": "46",
//         "shortText": "46",
//         "types": [
//             "street_number"
//         ]
//     },
//     {
//         "longText": "Tambotie Avenue",
//         "shortText": "Tambotie Ave",
//         "types": [
//             "route"
//         ]
//     },
//     {
//         "longText": "Val-De-Grace",
//         "shortText": "Val-De-Grace",
//         "types": [
//             "sublocality_level_1",
//             "sublocality",
//             "political"
//         ]
//     },
//     {
//         "longText": "Pretoria",
//         "shortText": "Pretoria",
//         "types": [
//             "locality",
//             "political"
//         ]
//     },
//     {
//         "longText": "City of Tshwane Metropolitan Municipality",
//         "shortText": "City of Tshwane Metropolitan Municipality",
//         "types": [
//             "administrative_area_level_2",
//             "political"
//         ]
//     },
//     {
//         "longText": "Gauteng",
//         "shortText": "GP",
//         "types": [
//             "administrative_area_level_1",
//             "political"
//         ]
//     },
//     {
//         "longText": "South Africa",
//         "shortText": "ZA",
//         "types": [
//             "country",
//             "political"
//         ]
//     },
//     {
//         "longText": "0184",
//         "shortText": "0184",
//         "types": [
//             "postal_code"
//         ]
//     }
// ]

// new object for place auto
// [
//   {
//     Dg: ["street_number"],
//     Eg: "46",
//     Fg: "46"
//   },
//   {
//     Dg: ["route"],
//     Eg: "Tambotie Avenue",
//     Fg: "Tambotie Ave"
//   },
//   {
//     Dg: ["sublocality_level_1", "sublocality", "political"],
//     Eg: "Val-De-Grace",
//     Fg: "Val-De-Grace"
//   },
//   {
//     Dg: ["locality", "political"],
//     Eg: "Pretoria",
//     Fg: "Pretoria"
//   },
//   {
//     Dg: ["administrative_area_level_2", "political"],
//     Eg: "City of Tshwane Metropolitan Municipality",
//     Fg: "City of Tshwane Metropolitan Municipality"
//   },
//   {
//     Dg: ["administrative_area_level_1", "political"],
//     Eg: "Gauteng",
//     Fg: "GP"
//   },
//   {
//     Dg: ["country", "political"],
//     Eg: "South Africa",
//     Fg: "ZA"
//   },
//   {
//     Dg: ["postal_code"],
//     Eg: "0184",
//     Fg: "0184"
//   }
// ]
